import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontClickEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {InfoBubblePillVariantsEnum} from '../../../common/infoBubbles/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

export const FirstMessageEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const {trackDataEvent} = useDataEventTracking();

  const onNextClick = (event: FrontClickEvent) => {
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.DEMO_CONVO, {});
    props.onNextClick(event);
  };

  return (
    <EducationTip
      anchor={props.anchor}
      position="bottom"
      isVisible={props.isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={<Trans id="infobubble-onboarding-first-message-title">Your fictional customer message</Trans>}
      stepCounter={generateStepText(1, 2)}
      onPrimaryClick={onNextClick}
      primaryActionLabel={<Trans id="infobubble-onboarding-first-message-primary">Got it</Trans>}
      dataObjectName={OnboardingDataEventObject.DEMO_CONVO}
    >
      <Trans id="infobubble-onboarding-first-message-description">
        Let&apos;s use this message to see how to collaborate with your teammates efficiently.
      </Trans>
    </EducationTip>
  );
};
